import { PopperDropdownManagerProps } from '@wix/da-ds/pkg/Dropdown/PopperDropdownLayout';

export const EXTENSION_TYPE_NAME = 'da-deviation';
export const popperDropdownConfig: PopperDropdownManagerProps = {
  mobileOpenDelay: true,
};
